//DETECT SCROLL
$(window).scroll(function() {
    var height = $(window).scrollTop();

    if( height  > 50 )
    {
        if ( !$('#header').hasClass('small_header') )
        {
            $('#header').addClass('small_header');
        }
    }
    else if ( $('#header').hasClass('small_header') )
    {
        $('#header').removeClass('small_header');
    }
});
